import React from 'react'
import { Breadcrumbs } from '../Shared/Breadcrumbs'
import { getBreadcrumbsFromParentPages } from '@/utilities/breadcrumbs'
import type { CMSParentPage } from '@/types/sanity'

type Props = {
  currentPageTitle: string
  parentPages?: CMSParentPage[]
}

export const BuyingPanelBreadcrumbs: React.FC<Props> = ({
  currentPageTitle,
  parentPages,
}) => {
  const { referrer } = document
  const breadcrumbs = parentPages
    ? [
        ...getBreadcrumbsFromParentPages({
          parentPages,
          referrer,
        }),
        { label: currentPageTitle },
      ]
    : []

  return <Breadcrumbs breadcrumbs={breadcrumbs} />
}
